import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=1010367c&lang=pug&"
import script from "./Management.vue?vue&type=script&lang=ts&"
export * from "./Management.vue?vue&type=script&lang=ts&"
import style0 from "./Management.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports